var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Button } from "../elements/button";
import { LinkButton } from '../elements/link-button';
var defaultComponents = {
  Button: Button,
  LinkButton: LinkButton
  // EntitySelect: EntitySelect,
};
var ComponentsContext = React.createContext({});
export var ComponentsProvider = function (_a) {
  var _b = _a.value,
    value = _b === void 0 ? {} : _b,
    children = _a.children;
  var components = __assign(__assign({}, defaultComponents), value);
  return React.createElement(ComponentsContext.Provider, {
    value: components
  }, children);
};
export var useComponents = function () {
  var context = React.useContext(ComponentsContext);
  if (!context || Object.keys(context).length === 0) {
    return defaultComponents;
  }
  return context;
};